import { useState } from "react";

export default function useRelevanceChanges() {

    const [relevanceChanges, setRelevanceChanges] = useState([]);

    const handleInsertRelevance = (product, relevance) => {

        setRelevanceChanges(prev => {

            const index = prev.findIndex(
                item => item.pd_id === product.pd_id
            );

            if (index !== -1) {

                const updated = [...prev];
                updated[index].relevance = relevance;
                return updated;

            }

            return [
                ...prev,
                {
                    pd_id: product.pd_id,
                    relevance
                }
            ];

        });

    };

    const clearRelevanceChanges = () => {
        setRelevanceChanges([]);
    };

    return {
        relevanceChanges,
        handleInsertRelevance,
        clearRelevanceChanges
    };

}